// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZqpNy","name":"styles_name__3hNJd","phone":"styles_phone__1b1sN"};